import { derived, writable } from "svelte/store";

import { createLogger } from "../logger";

const logger = createLogger("played-games");

/**
 * TODO(duanei): All of this is just temporary, so let's not overthink it.
 * It will be removed when we've started to sync the state with GX account instead.
 */
const key = "played-games";

type PlayedGames = {
  games: {
    id: number;
    url: string;
    timestamp: string;
    img: string;
  }[];
};

const playedGamesStorage = (() => {
  const { subscribe, update } = writable<PlayedGames>({ games: [] }, (set) => {
    try {
      const rawData = localStorage.getItem(key);

      if (rawData) {
        const state = JSON.parse(rawData);
        set(state);
      }
    } catch (error) {
      logger.error("Could not parse state:", error);
    }

    const handleStorageChanged = (event: StorageEvent) => {
      if (event.key !== key || !event.newValue) {
        return;
      }

      try {
        const newState = JSON.parse(event.newValue);
        set(newState);
      } catch (error) {
        logger.error("Could not parse state:", error);
      }
    };

    window.addEventListener("storage", handleStorageChanged);
    return () => window.removeEventListener("storage", handleStorageChanged);
  });

  const addPlay = (htmlGame: {
    id: number;
    game: { thumbnailMobileBig: { url: string } };
    url: string;
  }) => {
    update((currentState) => {
      const gameExists = currentState.games.some((game) => game.id === htmlGame.id);

      if (gameExists) {
        return currentState;
      }

      const newGame = {
        id: htmlGame.id,
        img: htmlGame.game.thumbnailMobileBig?.url,
        timestamp: new Date().toISOString(),
        url: htmlGame.url,
      };
      const updatedGames = [newGame, ...currentState.games];
      const newState = {
        games: updatedGames,
      };

      localStorage.setItem(key, JSON.stringify(newState));
      return newState;
    });
  };

  return { addPlay, subscribe };
})();

export const playedGames = (() => {
  const { addPlay } = playedGamesStorage;
  const { subscribe } = derived([playedGamesStorage], ([$playedGames]) => {
    return { ...$playedGames };
  });
  return { addPlay, subscribe };
})();
